module.exports = __webpack_public_path__ + "facepalmcry.287f085c.png";